import { Checkbox, Dialog, DialogContent, Grid, FormControlLabel } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Header, TitleText, SubHeading, Footer, DialogActionButton } from './styles';

type Props = {
  open: boolean;
  onClose: () => void;
  visibleColumns: GridColDef[];
  columns: GridColDef[];
  setVisibleColumns: Dispatch<SetStateAction<GridColDef[]>>;
};

export const ColumnListingDialog = ({
  open,
  onClose,
  visibleColumns,
  columns,
  setVisibleColumns,
}: Props) => {
  const [checkedColumns, setCheckedColumns] = useState<Record<string, boolean>>({});

  const handleCheckboxChange = (selectedColumn: GridColDef) => {
    setCheckedColumns((previous) => ({
      ...previous,
      [selectedColumn.field]:
        selectedColumn.field === 'name' ? true : !previous[selectedColumn.field],
    }));
  };

  useEffect(() => {
    const updatedCheckedColumns: Record<string, boolean> = {};
    visibleColumns.forEach((column) => {
      updatedCheckedColumns[column.field] = true;
    });

    setCheckedColumns(updatedCheckedColumns);
  }, [visibleColumns]);

  const handleApply = () => {
    setVisibleColumns(columns.filter((column) => checkedColumns[column.field]));
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          maxWidth: '82rem',
        },
      }}
    >
      <Header>
        <TitleText>Enable the columns you would like to see in the table</TitleText>
      </Header>
      <DialogContent sx={{ paddingLeft: '4.4rem' }}>
        <SubHeading>Select the columns you want to display:</SubHeading>
        <Grid container paddingBottom="4rem" rowSpacing="0.5rem" width="100%">
          {columns.map((column) => (
            <Grid item xs={3} key={column.field}>
              <FormControlLabel
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '1.4rem',
                  },
                }}
                control={
                  <Checkbox
                    checked={checkedColumns[column.field]}
                    onChange={() => handleCheckboxChange(column)}
                  />
                }
                label={column.headerName}
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <Footer>
        <DialogActionButton onClick={handleCancel}>Cancel</DialogActionButton>
        <DialogActionButton onClick={handleApply} contained>
          Apply
        </DialogActionButton>
      </Footer>
    </Dialog>
  );
};
